<label class="ss-form-check" [class.ss-form-check-square]="square">
  <input type="checkbox" [(ngModel)]="value" [disabled]="disabled" (change)="handleChange($event)">
  <span class="ss-form-check-text">{{label}}</span>
  <span class="ss-dot">
    <app-icon-check size="10" color="white"></app-icon-check>
  </span>
</label>
